import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"
import sizes from "@frog/source/data/sizes.js"
import {getReferencedUnit} from "@frog/source/data/units.js"
import CombatEncounter from "@frog/source/models/CombatEncounter.js"
import Text from "@frog/source/views/Text.view.js"
import Loop from "@frog/source/utility/Loop.js"
import Pointer from "poin"
import {getTime} from "@frog/source/juice/utility/Time.js"

const BUTTON_PRESSED_COLOR = "#fbfcdf"

function getPortrait(unit) {
    if(unit == undefined) {
        return
    }
    if(unit.affiliation == "bad") {
        return unit.images.portraitred || unit.images.portrait
    }
    if(unit.affiliation == "undead") {
        return unit.images.portraitgreen || unit.images.portrait
    }
    return unit.images.portrait
}

export default function Interface(stage) {
    return {
        "key": "Interface",
        "width": "100%",
        "height": "100%",
        "stack": 999,
        "_": [
            Tutorial(stage),
            // UnitSkills(stage), // debug'd out
            {
                "key": "TopHud",
                "width": "100%",
                "position": {"x": 0, "y": 0},
                "_": [
                    // {
                    //     "key": "Panel",
                    //     "image": require("@frog/source/assets/images/hero-tactics/ui/panel-top.png").default,
                    //     "position": {"x": 0, "y": 0},
                    // },
                    App.game.encounter.phase == "play" && {
                        "key": "UndoButton",
                        "position": {"x": 8, "y": 6},
                        // "position": {"x": sizes.canvas.width - 8, "y": 6},
                        // "anchor": {"x": "100%"},
                        "image": require("@frog/source/assets/images/apocalypse-tactics/ui/buttons/undo.png").default,
                        "events": {
                            "cursordown": () => {
                                Pointer.isIgnoringForFrame = 10
                                App.game.encounter.undoAction()
                            }
                        },
                        "color": "#e6db33",
                        "overrides": {
                            "hovered": {
                                "color": BUTTON_PRESSED_COLOR,
                            },
                            "pressed": {
                                "color": BUTTON_PRESSED_COLOR,
                            },
                        },
                        // "_": [
                        //     {
                        //         "key": "Text",
                        //         "_": [
                        //             Text("Undo"),
                        //         ]
                        //     }
                        //     // {
                        //     //     "key": "Panel",
                        //     //     "image": require("@frog/source/assets/images/hero-tactics/ui/panel-right.png").default,
                        //     //     "position": {"x": 0, "y": 0},
                        //     //     "events": {
                        //     //         "cursordown": () => App.game.encounter.undoAction()
                        //     //     }
                        //     // },
                        //     // {
                        //     //     "key": "Text",
                        //     //     "image": require("@frog/source/assets/images/hero-tactics/ui/undo.png").default,
                        //     //     "position": {"x": 8, "y": 5},
                        //     // }
                        // ]
                    },
                    App.game.encounter.phase == "play" && {
                        "key": "EndTurnButton",
                        "position": {"x": 8, "y": 6 + 16 + 16},
                        // "position": {"x": sizes.canvas.width - 8, "y": 6 + 16},
                        // "anchor": {"x": "100%"},
                        "image": require("@frog/source/assets/images/apocalypse-tactics/ui/buttons/end.png").default,
                        "events": {
                            "cursordown": () => {
                                if(window.tutorial < 4) {
                                    window.tutorial = 4
                                }
                                Pointer.isIgnoringForFrame = 10
                                App.game.encounter.endPlayerTurn()
                            }
                        },
                        "color": "#e69633",
                        "overrides": {
                            "hovered": {
                                "color": BUTTON_PRESSED_COLOR,
                            },
                            "pressed": {
                                "color": BUTTON_PRESSED_COLOR,
                            },
                        },
                        // "_": [
                        //     {
                        //         "key": "Text",
                        //         "_": [
                        //             Text("End Turn"),
                        //         ]
                        //     }
                        //     // {
                        //     //     "key": "Panel",
                        //     //     "image": require("@frog/source/assets/images/hero-tactics/ui/panel-left.png").default,
                        //     //     "position": {"x": 0, "y": 0},
                        //     //     "events": {
                        //     //         "cursordown": () => {
                        //     //             App.game.encounter.endPlayerTurn()
                        //     //         }
                        //     //     }
                        //     // },
                        //     // {
                        //     //     "key": "Text",
                        //     //     "image": require("@frog/source/assets/images/hero-tactics/ui/done.png").default,
                        //     //     "position": {"x": 3, "y": 5},
                        //     // }
                        // ]
                    },
                    App.game.encounter.phase == "prepare" && Object.values(stage.units).filter((unit) => unit.hasBeenRemoved != true && unit.affiliation == "good" && (unit.position.x == -10 && unit.position.y == -10) != true).length > 0 && {
                        "key": "StartButton",
                        "position": {"x": "50%", "y": 12},
                        "anchor": {"x": "50%"},
                        "image": require("@frog/source/assets/images/apocalypse-tactics/ui/buttons/start.png").default,
                        "events": {
                            "cursordown": () => {
                                Pointer.isIgnoringForFrame = 10
                                App.game.encounter.startPlayPhase({
                                    "dialogue": App.game.encounter.slug + ".start"
                                })
                            }
                        },
                        "color": "#e69532",
                        "overrides": {
                            "hovered": {
                                "color": BUTTON_PRESSED_COLOR,
                            },
                            "pressed": {
                                "color": BUTTON_PRESSED_COLOR,
                            },
                        },
                    }
                ]
            },
            {
                "key": "BottomHud",
                "anchor": {"y": "100%"},
                "position": {"y": "100%"},
                "height": 16,
                "width": "100%",
                "_": [
                    // {
                    //     "key": "Panel",
                    //     // "anchor": {"y": "100%"},
                    //     // "position": {"y": "100%"},
                    //     "image": require("@frog/source/assets/images/hero-tactics/ui/panel-bottom.png").default,
                    // },
                    UnitDetails(stage),
                ]
            },
            App.game.encounter.phase == "play" && StageText(stage),
            App.game.encounter.phase == "play" && CurrentScore(stage),
            Dialogue(stage),
            PreparePopUp(),
        ]
    }
}

function PreparePopUp() {
    if(App.game.encounter.phase != "prepare") return
    return {
        "width": "100%",
        "height": "100%",
        "_": [
            {
                "key": "PreparePopUp",
                "width": 64,
                "height": "100%",
                "anchor": {"x": "100%"},
                "position": {"x": "100%"},
                "stack": 999,
                "color": "#e69532",
                "_": Object.values(App.game.player.party.units).filter((unit) => {
                    return unit.isUnlocked == true
                        && getReferencedUnit(unit).type != "plant"
                }).map((unit, index) => {
                    return {
                        "position": {
                            "x": 3,
                            "y": 4 + 13 * index,
                        },
                        "opacity": App.game.encounter.stage.units[unit.key].hasBeenRemoved ? 1 : 0.5,
                        "color": App.game.encounter.selection.selectedUnitKey == unit.key ? "white" : undefined,
                        "overrides": {
                            "hovered": {
                                "color": "yellow",
                            },
                            "pressed": {
                                "color": "white",
                            },
                        },
                        "events": {
                            "cursordown": () => {
                                Pointer.isIgnoringForFrame = 10
                                if(App.game.encounter.stage.units[unit.key].hasBeenRemoved == true) {
                                    App.game.encounter.stage.units[unit.key].hasBeenRemoved = false
                                    App.game.encounter.selection.select(unit.key)
                                } else {
                                    App.game.encounter.stage.units[unit.key].hasBeenRemoved = true
                                }
                            }
                        },
                        "_": [
                            Text(getReferencedUnit(unit).name)
                        ]
                    }
                })
            },
            {
                "key": "PreparePopUp",
                "width": 64,
                "height": "100%",
                "stack": 999,
                "color": "#e69532",
                "_": Object.values(App.game.player.party.units).filter((unit) => {
                    return unit.isUnlocked == true
                        && getReferencedUnit(unit).type == "plant"
                }).map((unit, index) => {
                    return {
                        "position": {
                            "x": 3,
                            "y": 4 + 13 * index,
                        },
                        "opacity": App.game.encounter.stage.units[unit.key].hasBeenRemoved ? 1 : 0.5,
                        "color": App.game.encounter.selection.selectedUnitKey == unit.key ? "white" : undefined,
                        "overrides": {
                            "hovered": {
                                "color": "yellow",
                            },
                            "pressed": {
                                "color": "white",
                            },
                        },
                        "events": {
                            "cursordown": () => {
                                Pointer.isIgnoringForFrame = 10
                                if(App.game.encounter.stage.units[unit.key].hasBeenRemoved == true) {
                                    App.game.encounter.stage.units[unit.key].hasBeenRemoved = false
                                    App.game.encounter.selection.select(unit.key)
                                } else {
                                    App.game.encounter.stage.units[unit.key].hasBeenRemoved = true
                                }
                            }
                        },
                        "_": [
                            Text(getReferencedUnit(unit).name)
                        ]
                    }
                })
            }
        ]
    }
}

function StageText(stage) {
    // if(App.game.encounter.sequence.steps > 0) {
    //     stage = App.game.encounter.sequence.steps[0].stage
    // }
    if(App.game.encounter.phase == "success"
    || App.game.encounter.phase == "failure") {
        return
    }
    if(stage.prompt == undefined) return
    const prompt = stage.prompt(stage)
    return {
        "position": {"x": "50%", "y": "7%"},
        "anchor": {"x": "50%", "y": "0%"},
        "color": prompt.onClick != undefined ? "#e69633" : undefined,
        "overrides": prompt.onClick != undefined && {
            "hovered": {
                "color": "#e6db33",
            },
        },
        "events": prompt.onClick != undefined && {
            "cursordown": prompt.onClick
        },
        "_": [
            Text({
                "text": prompt.text
            })
        ]
    }
}

import Stage from "@frog/source/models/Stage.js"
function CurrentScore(stage) {
    let score = Stage.getScore(stage)
    if(score == undefined) return
    return {
        "position": {"x": "50%", "y": "95%"},
        "anchor": {"x": "50%", "y": "100%"},
        "_": [
            Text({
                "text": "Harvested " + score + " crop" + (score == 1 ? "" : "s")
            })
        ]
    }
}


import elements from "@frog/source/data/elements.js"
import skills from "@frog/source/data/skills/skills.js"
import pointer from "poin"
// import Stage from "@frog/source/views/Stage.view.js"
import PercentageHealthBar from "@frog/source/views/PercentageHealthBar.view.js"

function UnitDetails(stage) {
    return // DEBUG
    if(stage?.dialogue != undefined) {
        return
    }
    const unit = App.game.encounter.selection.selectedUnit || App.game.encounter.selection.hoveredUnit
    if(unit != undefined
    && unit.affiliation != "none") {

        let nextActionUnit = undefined
        if(App.game.encounter != undefined
        && App.game.encounter.selection != undefined
        && App.game.encounter.selection.hoveredAction != undefined
        && App.game.encounter.selection.hoveredAction.omegastage != undefined
        && App.game.encounter.selection.hoveredAction.omegastage.units != undefined
        && App.game.encounter.selection.hoveredAction.omegastage.units[unit.key] != undefined) {
            nextActionUnit = App.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
        }

        return {
            "key": "UnitDetails",
            "position": {"x": 0, "y": 0},
            "_": [
                {
                    "key": "Summary",
                    "_": [
                        {
                            // "x": -16,
                            "y": 16,
                            "anchor": {"y": "100%"},
                            // "position": {"y": -4},
                            // "width": 20,
                            // "height": 20,
                            // "image": require("@frog/source/assets/images/hero-tactics/portraits/fegba-/harken.png").default,
                            "image": getPortrait(unit),
                            // "width": 100 / 4,
                            // "height": 80 / 4,
                            // "isFlipped": true,
                            // "image": require("@frog/source/assets/images/hero-tactics/portraits/fegba/harken.png").default,
                        }
                    ]
                },
                {
                    "width": 26,
                    "position": {"x": (96 / 2) - 16 + 2, "y": 0},
                    "_": [
                        {
                            "position": {"x": "50%", "y": 3},
                            "anchor": {"x": "50%"},
                            "_": [
                                // {"image": require("@frog/source/assets/images/hero-tactics/ui/hp.png").default},
                                Text({
                                    "text": unit.health + "/" + unit.maxhealth,
                                    "font": "numbers",
                                })
                            ]
                        },
                        {
                            "position": {"x": 0, "y": 13},
                            "width": 26,
                            "height": 2,
                            "color": "yellow",
                            "_": [PercentageHealthBar({unit, nextActionUnit})]
                        },
                    ]
                },
                {
                    // "key": "Skills",
                    "position": {"x": (96 / 2) - 16 + 2 + 26 + 2, "y": 3},
                    "_": [
                        Text(unit.name || unit.className),
                    ],
                    // "_": Object.values(unit.equippedSkills).map((skillKey, index) => {
                    //     const skill = skills.get(skillKey)
                    //     if(skill == undefined) return
                    //
                    //     // TODO: MAKE ALL STAGES ASSUME A 0x0 CAMERA
                    //     // WITHOUT BREAKING THE SELECTION LOGIC.
                    //     if(skill.demonstration != undefined
                    //     && skill.demonstration.sequence != undefined
                    //     && skill.demonstration.sequence.steps != undefined
                    //     && skill.demonstration.sequence.steps[0] != undefined
                    //     && skill.demonstration.sequence.steps[0].alphastage != undefined) {
                    //         skill.demonstration.sequence.steps[0].alphastage.camera = {
                    //             "position": {
                    //                 "x": -8,
                    //                 "y": -16 // TODO: I WISH THE CAMERA DIDN'T REQUIRE KNOWLEDGE OF THE ANCHOR
                    //             }
                    //         }
                    //     }
                    //     return {
                    //         "key": "Skill/" + skillKey,
                    //         "position": {
                    //             "x": index * (16 + 2),
                    //             "y": 0, // -2,
                    //         },
                    //         "_": [
                    //             {
                    //                 "key": "Icon",
                    //                 "image": skill.icon || require("@frog/source/assets/images/hero-tactics/skills/fe/Aether.png").default,
                    //                 // "position": {"x": 0, "y": 0},
                    //                 // "position": {"y": -4},
                    //                 "events": {
                    //                     "cursordown": () => {
                    //                         pointer.isIgnoringForFrame = 5
                    //                         if(App.game.encounter.selection.selectedSkillKey != skillKey) {
                    //                             App.game.encounter.selection.selectedSkillKey = skillKey
                    //                         } else {
                    //                             App.game.encounter.selection.selectedSkillKey = undefined
                    //                         }
                    //                     },
                    //                     // "cursorover": () => {
                    //                     //     // console.log("OVER")
                    //                     //     App.game.encounter.selection.hoveredSkillKey = skillKey
                    //                     // },
                    //                     // "cursorout": () => {
                    //                     //     // console.log("OUT")
                    //                     //     App.game.encounter.selection.hoveredSkillKey = undefined
                    //                     // },
                    //                 }
                    //             },
                    //             // skill.demonstration != undefined
                    //             // && skill.demonstration.sequence != undefined
                    //             // && skill.demonstration.sequence.steps != undefined
                    //             // && skill.demonstration.sequence.steps[0] != undefined
                    //             // && skill.demonstration.sequence.steps[0].alphastage != undefined
                    //             // && {
                    //             //     "position": {"x": 0, "y": -9 * 16},
                    //             //     "width": (16 * 5) + 2,
                    //             //     "height": (16 * 3) + 2, // TODO: DON'T HARDCODE THIS SOMEHOW??
                    //             //     "color": "black",
                    //             //     "_": [
                    //             //         {
                    //             //             "position": {"x": 1, "y": 1},
                    //             //             "_": [
                    //             //                 Stage(skill.demonstration.sequence.steps[0].alphastage)
                    //             //             ]
                    //             //         }
                    //             //     ]
                    //             // }
                    //         ]
                    //     }
                    // })
                }
            ]
        }
    }
    // if(App.game.encounter.selection.hoveredUnit != undefined
    // && App.game.encounter.selection.hoveredUnit.affiliation != "none") {
    //     const unit = App.game.encounter.selection.hoveredUnit
    // }
}


function UnitSkills(stage) {
    if(stage == undefined) {
        return
    }
    if(stage.dialogue != undefined) {
        return
    }
    const unit = App.game.encounter.selection.selectedUnit || App.game.encounter.selection.hoveredUnit
    if(unit != undefined
    && unit.affiliation != "none") {
        return {
            "key": "UnitSkills",
            "anchor": {"x": "100%", "y": "0%"},
            "position": {"x": sizes.canvas.width - 8, "y": 0},
            "_": Object.values(unit.equippedSkills).map((skillKey, index) => {
                return {
                    "position": {
                        "y": 6 + index * 12,
                    },
                    // "width": 40,
                    "height": 12,
                    // "color": "orange",
                    "anchor": {"x": "100%"},
                    "_": [
                        // Text("#" + (index + 1) + ": " + skills.get(skillKey).name),
                        Text("#" + (index + 1) + ": " + skills.get(skillKey).name + (skills.get(skillKey).icon ? " " : "")),
                        skills.get(skillKey).icon && {
                            "image": skills.get(skillKey).icon,
                            "anchor": {"y": 4},
                        }
                    ],
                    "events": {
                        "cursordown": () => {
                            Pointer.isIgnoringForFrame = 10
                            App.game.encounter.selection.selectedSkillKey = skillKey
                        }
                    }
                }
            })
        }
    }
}

import Dialogue from "@frog/source/views/Dialogue.view.js"


// class UnitSkill {
//     render() {
//         const skill = skills.get(this.props.skillKey)
//         if(skill == undefined) return
//         return (
//             <div class="Skill"
//                 skillClass={skill.class}
//                 isSelected={this.isSelected}>
//                 <div class="About">
//                     {this.props.skillKey == App.game.encounter.selection.hoveredSkillKey && (
//                         <div class="Box">
//                             <div class="Text">
//                                 <div class="Overview">
//                                     <div class="Name">{skill.name}</div>
//                                     <ElementIcon elementKey={skill.element}/>
//                                 </div>
//                                 <div class="Preview">
//                                     <Stage stage={skill?.demonstration?.sequence?.steps[0]?.stage}/>
//                                 </div>
//                                 <div class="Details">
//                                     <div class="Keywords">
//                                         <span class="Keyword">
//                                             {skill.range.name}-range
//                                         </span>
//                                         <span> • </span>
//                                         <span class="Keyword">
//                                             {elements[skill.element].name}-type
//                                         </span>
//                                         <span> • </span>
//                                         <span class="Keyword">
//                                             Level 1
//                                         </span>
//                                     </div>
//                                     <div class="Description">
//                                         <FormattedText text={this.description}/>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//                 <div class="Icon" style={{"background-image": "url(" + skill.icon + ")"}}>
//                     {this.shortcutKey}
//                 </div>
//             </div>
//         )
//     }
//     get isSelected() {
//         if(this.props.unit.energy["invoke skill"] === false) return false
//         if(this.props.skillKey == App.game.encounter.selection?.hoveredAction?.skillKey) return true
//         if(this.props.skillKey == App.game.encounter.selection.selectedSkillKey) return true
//     }
//     get isHovered() {
//         if(this.props.unit.energy["invoke skill"] === false) return false
//         if(this.props.skillKey == App.game.encounter.selection.hoveredSkillKey) return true
//     }
//     // get hasEnergyForInvokingSkills() {
//     //     return this.props.unit.energy["invoke skill"] != false
//     // }
//     get shortcutKey() {
//         if(this.props.unit.affiliation != "good") return
//         return (
//             <div class="ShortcutKey">
//                 {this.props.index + 1}
//             </div>
//         )
//     }
//     get description() {
//         const skill = skills.get(this.props.skillKey)
//         if(skill instanceof Function) return skill.description()
//         return skill.description
//     }
// }

import NineCut from "@frog/source/views/NineCut.view.js"

window.tutorial = -1
window.tutorial2 = -1
function Tutorial(stage) {
    if(stage.dialogue != undefined) return
    if(App.game.encounter.slug != "first_day") return

    if(App.game.encounter.stage.turn.number == 0) {
        if(window.tutorial == 0) {
            return {
                "position": {
                    "x": 320,
                    "y": 16 * 7,
                },
                "_": [
                    NineCut({
                        "width": 14,
                        "height": 9,
                    }),
                    [
                        "Let's crush these",
                        "bugs! Click on a",
                        "unit to select them.",
                    ].map((text, index) => {
                        return {
                            "position": {
                                "x": 14,
                                "y": ((index + 1) * (16)) - 4,
                            },
                            "_": [
                                Text({
                                    "text": text,
                                    "font": "dialogue",
                                })
                            ]
                        }
                    })
                ]
            }
        }

        // if(window.tutorial == 0.5) {
        //     return {
        //         "position": {
        //             "x": 50,
        //             "y": 16 * 6.5,
        //         },
        //         "_": [
        //             NineCut({
        //                 "width": 6,
        //                 "height": 3,
        //                 "images": box,
        //                 "tilewidth": 32,
        //                 "tileheight": 32,
        //             }),
        //             [
        //                 "Nah, no fish there.",
        //                 "Use undo to pike",
        //                 "the spot over here!"
        //             ].map((text, index) => {
        //                 return {
        //                     "position": {
        //                         "x": 22,
        //                         "y": ((index + 1) * (16 + 4)) - 3,
        //                     },
        //                     "_": [
        //                         Text({
        //                             "text": text,
        //                             "font": "dialogue",
        //                         })
        //                     ]
        //                 }
        //             })
        //         ]
        //     }
        // }

        if(window.tutorial == 1) {
            return {
                "position": {
                    "x": 30,
                    "y": 16 * 9,
                },
                "_": [
                    NineCut({
                        "width": 15,
                        "height": 7,
                    }),
                    [
                        "Excellent!! Now click",
                        "on a bug to squash.",
                    ].map((text, index) => {
                        return {
                            "position": {
                                "x": 14,
                                "y": ((index + 1) * (16)) - 4,
                            },
                            "_": [
                                Text({
                                    "text": text,
                                    "font": "dialogue",
                                })
                            ]
                        }
                    })
                ]
            }
        }

        if(window.tutorial >= 2
        && Object.values(stage.units).filter((unit) => unit.affiliation == "good" && unit.energy["invoke skill"] == false).length == 2) {
            return {
                "position": {
                    "x": 8,
                    "y": 16 * 14,
                },
                "_": [
                    NineCut({
                        "width": 13,
                        "height": 7,
                    }),
                    [
                        "Now click END to",
                        "end your turn.",
                    ].map((text, index) => {
                        return {
                            "position": {
                                "x": 14,
                                "y": ((index + 1) * (16)) - 4,
                            },
                            "_": [
                                Text({
                                    "text": text,
                                    "font": "dialogue",
                                })
                            ]
                        }
                    })
                ]
            }
        }
    }

    if(App.game.encounter.stage.turn.number == 2) {
        if(window.tutorial2 == 0) {
            return {
                "position": {
                    "x": 360,
                    "y": 16 * 7,
                },
                "_": [
                    NineCut({
                        "width": 14,
                        "height": 9,
                    }),
                    [
                        "To grow a crop,",
                        "have one of your",
                        "units water them.",
                    ].map((text, index) => {
                        return {
                            "position": {
                                "x": 14,
                                "y": ((index + 1) * (16)) - 4,
                            },
                            "_": [
                                Text({
                                    "text": text,
                                    "font": "dialogue",
                                })
                            ]
                        }
                    })
                ]
            }
        }

        if(window.tutorial2 == 1) {
            return {
                "position": {
                    "x": 30,
                    "y": 16 * 7.5,
                },
                "_": [
                    NineCut({
                        "width": 15,
                        "height": 7,
                    }),
                    [
                        "Just like that! They'll",
                        "be grown in no time!",
                    ].map((text, index) => {
                        return {
                            "position": {
                                "x": 14,
                                "y": ((index + 1) * (16)) - 4,
                            },
                            "_": [
                                Text({
                                    "text": text,
                                    "font": "dialogue",
                                })
                            ]
                        }
                    })
                ]
            }
        }
    }
}
